import React, { useContext } from 'react';
import { createPortal } from 'react-dom';
import moment from 'moment';
import useUser from '../../hooks/useUser';

const Viewer = ({ user, createdAt }) => (
    <li className="flex mb2">
        <img className="avatar mr2 flex-none" height="28" width="28" src={user.image_192} />
        <a className="flex-auto" href={user.url}>{user.display_name}</a>
        <span className="gray flex-none">{moment.utc(createdAt).local().format('L LT')}</span>
    </li>
);

const ViewerListElement = (props) => {
    const { user_id, createdAt } = props;
    const user = useUser(user_id);
    if (!user) return null;

    return <Viewer user={user} createdAt={createdAt} />;
};

const CurrentUserView = () => {
    const user = useUser(window.userId);
    if (!user) return null;

    const createdAt = moment.utc();
    if (!user.display_name.includes('You')) {
        user.display_name += ' (You)';
    }

    return <Viewer user={user} createdAt={createdAt} />;
};

const PageViewersModal = (props) => {
    const { views, anonViewCount, page } = props;

    const onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (props.closeModal && className && className.includes('react-modal open')) {
            props.closeModal();
        }
    };

    const updatedTime = moment.utc(page.updated_at).local().format('L LT');

    const viewsWithoutCurrentUser = views.filter(view => view.user_id != window.userId);

    return (
        <div className="react-modal open" id="page-viewers-modal" onMouseDown={onClickModal}>
            <div className="modal-content p2">
                <h2>Page Viewers</h2>
                <p className="gray">
                    {'Page last updated '}
                    <span id="page-view-updated-time">{updatedTime}</span>
                </p>
                <ul id="page-viewers-list" className="page-viewers-list">
                    <CurrentUserView />
                    {viewsWithoutCurrentUser.map(view => <ViewerListElement user_id={view.user_id} createdAt={view.created_at} key={`viewer-${view.id}`} />)}
                    {anonViewCount !== 0 && (
                        <li className="flex mb2 gray">{`${anonViewCount} anonymous views`}</li>
                    )}
                </ul>
                <div className="right-align">
                    <span className="btn-secondary mr1" onClick={props.closeModal}>Close</span>
                </div>
            </div>
        </div>
    );
};

export default (props) => createPortal(<PageViewersModal {...props} />, document.body);
